import { SesamiSDKGlobal } from '@/@types/calendar';
import CalendarDay from './CalendarDay';

type Props = {
  row: SesamiSDKGlobal['data']['rows'][number];
};

function CalendarWeek({ row }: Props) {
  return (
    <>
      {row.map((day) => {
        return <CalendarDay key={day.date.toISOString()} day={day} />;
      })}
    </>
  );
}

export default CalendarWeek;
